<script>
export default {
  translate25Context: "stepin",
  props: {
    component: Object,
    handler: Object,
  },
  data() {
    return {
      selectedTab: "candidates",
      pending: false,
      message: "",
      autoscroll: true,
      timeout: null,
    };
  },
  methods: {
    startChat: async function (candidate) {
      this.pending = true;
      try {
        await this.handler.action(candidate, "start_chat", []);
      } catch {}
      this.pending = false;
    },
    reject: async function (candidate) {
      this.pending = true;
      try {
        await this.handler.action(candidate, "reject", []);
      } catch {}
      this.pending = false;
    },
    close: async function (candidate) {
      this.pending = true;
      try {
        await this.handler.action(candidate, "close", []);
      } catch {}
      this.pending = false;
    },
    sendMessage: async function (candidate) {
      if (!this.message) return;
      // this.pending = true;
      try {
        await this.handler.action(candidate, "send_message", [this.message]);
      } catch {}
      this.message = "";
      // this.pending = false;
    },
    availableActions: function (actions) {
      return Object.values(actions).filter((action) => action.value);
    },
    autoload: function (active) {
      this.autoscroll = active;
    },
    messageMounted: function ($message) {
      if (!this.autoscroll) return;

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(
        function () {
          $message.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }.bind(this)
      );
    },
    selectedCandidate(candidate) {
      this.message = "";
      this.handler.action(candidate, "select_candidate");
      if (candidate && !candidate.read)
        this.handler.action(candidate, "read", []);
    },
  },
};
</script>

<template>
  <f-form class="stepin-vconsole17">
    <template #content>
      <f-mini-tabs>
        <f-mini-tab
          :selected="selectedTab == 'candidates'"
          @select="selectedTab = 'candidates'"
          >{{ $vt("Participants") }}</f-mini-tab
        >
        <f-mini-tab
          :selected="selectedTab == 'closed_candidates'"
          @select="selectedTab = 'closed_candidates'"
          >{{ $vt("Closed") }}</f-mini-tab
        >
      </f-mini-tabs>

      <div class="content">
        <div class="candidates">
          <div class="candidates-list">
            <f-sexy-scroll>
              <div class="candidates-list-items">
                <div
                  class="candidate"
                  @click="selectedCandidate(candidate)"
                  v-for="(candidate, candidateNid) in component[selectedTab]"
                  :class="{
                    selected: component.selected_candidate.nid == candidateNid,
                  }"
                  :key="candidate['#id']"
                >
                  <div
                    class="candidate-unread"
                    v-if="candidate.read_info"
                    :class="{ unread: candidate.read_info.unread }"
                  >
                    {{ candidate.read_info.total }}
                  </div>
                  <div class="candidate-content">
                    <div class="candidate-name-and-date">
                      <div class="candidate-name">
                        {{ candidate.name }}
                      </div>
                      <div
                        class="candidate-closed"
                        v-if="selectedTab == 'closed_candidates'"
                      >
                        {{ $vt("Closed") }}
                      </div>
                      <div class="candidate-date">
                        {{
                          (candidate.created * 1000)
                            | angularFilter("HH:mm", "date")
                        }}
                      </div>
                    </div>
                    <div class="candidate-request">
                      {{ candidate.request }}
                    </div>
                  </div>
                </div>
              </div>
            </f-sexy-scroll>
            <div
              class="no-candidate-selected"
              v-if="Object.keys(component[selectedTab]).length == 0"
            >
              <f-icon icon="fa6-info"></f-icon>
              {{ $vt("No participant yet") }}
            </div>
          </div>

          <div class="candidate-chat">
            <div
              class="candidate-selected"
              v-if="component.selected_candidate.nid"
            >
              <div class="candidate-selected-messages">
                <f-sexy-scroll
                  :autoscrollEvent="true"
                  :autoscroll-tolerance="50"
                  @autoload="autoload"
                >
                  <div class="scroll-items">
                    <div class="request">
                      <div class="author">
                        {{ component.selected_candidate.name }}
                      </div>
                      <div class="text">
                        {{ component.selected_candidate.request }}
                      </div>
                      <div class="date">
                        {{
                          (component.selected_candidate.created * 1000)
                            | angularFilter("HH:mm", "date")
                        }}
                      </div>
                      <component
                        v-for="message in component.selected_candidate.messages"
                        :key="message['#id']"
                        :is="message.data['#type']"
                        :component="message"
                        :handler="handler"
                        @mounted="messageMounted"
                      ></component>
                    </div>
                  </div>
                </f-sexy-scroll>
              </div>
              <div class="actions">
                <f-button
                  v-if="!component.selected_candidate.state"
                  type="primarty negative"
                  :pending="pending"
                  @click="reject(component.selected_candidate)"
                  ><f-icon icon="fa6-circle-xmark"></f-icon>{{ $vt("Reject") }}</f-button
                >
                <f-button
                  v-if="!component.selected_candidate.state"
                  type="primary"
                  :pending="pending"
                  @click="startChat(component.selected_candidate)"
                  ><f-icon icon="fa6-message"></f-icon>{{ $vt("Start chat") }}</f-button
                >
                <f-button
                  v-if="component.selected_candidate.state == 'chat_enabled'"
                  type="primarty negative"
                  :pending="pending"
                  @click="close(component.selected_candidate)"
                  ><f-icon icon="fa6-circle-xmark"></f-icon>{{ $vt("Close") }}</f-button
                >
                <f-button
                  v-if="
                    ['closed', 'rejected'].indexOf(
                      component.selected_candidate.state
                    ) != -1
                  "
                  type="primary"
                  :pending="pending"
                  @click="startChat(component.selected_candidate)"
                  ><f-icon icon="fa6-message"></f-icon>{{ $vt("Start chat") }}</f-button
                >
                <div
                  v-if="
                    component.selected_candidate.extra_chat_enabled_component &&
                    component.selected_candidate.state == 'chat_enabled'
                  "
                >
                  <vue-angular-place-holder
                    :component="
                      component.selected_candidate.extra_chat_enabled_component
                        .component
                    "
                    :handler="handler"
                  >
                  </vue-angular-place-holder>
                </div>
              </div>
              <div class="input">
                <div class="stepin-player-chat-textarea">
                  <f-textarea
                    :input.sync="message"
                    :disabled="
                      component.selected_candidate.state != 'chat_enabled'
                    "
                    maxlength="255"
                    :disable-line-break="true"
                    @enter="sendMessage(component.selected_candidate)"
                  >
                    <template #actions>
                      <f-button
                        :disabled="
                          component.selected_candidate.state != 'chat_enabled'
                        "
                        type="icon small"
                        @click="sendMessage(component.selected_candidate)"
                        ><f-icon icon="fa6-share-from-square"></f-icon
                      ></f-button>
                    </template>
                  </f-textarea>
                </div>
              </div>
            </div>
            <div
              class="no-candidate-selected"
              v-if="!component.selected_candidate.nid"
            >
              <f-icon icon="fa6-info"></f-icon>
              {{ $vt("No chat opened") }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </f-form>
</template>

<style lang="scss">
stepin-vconsole17-ng {
  width: 0;
}

.stepin-vconsole17 {
  .stepin-modal {
    .f-dialog {
      width: 500px;

      .f-hint {
        margin-bottom: 24px;
      }
    }
  }
}
.stepin-vconsole17 {
  position: relative;
  height: 100%;

  .content {
    .candidates {
      display: flex;
      height: 100%;
      .candidates-list {
        display: flex;
        flex-direction: column;
        padding: 16px 0;
        flex: 0 0 50%;
        border-right: 1px solid var(--white-a10);
        height: 100%;
        width: 0;

        .f-sexy-scroll {
          height: 0;
          flex: 1 1 auto;
          .candidates-list-items {
            display: flex;
            flex-direction: column;
            gap: 16px;
            padding: 0 16px;

            .candidate {
              display: flex;
              border: solid 1px var(--white-a25);
              border-radius: 8px;
              align-items: center;
              gap: 8px;
              padding: 12px 8px;
              cursor: pointer;
              width: 100%;

              &:hover,
              &.selected {
                outline: 2px solid var(--navigation);
                outline-offset: -2px;
              }

              .candidate-unread {
                background-color: var(--white-a10);
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 100%;
                font-weight: bold;
                color: var(--white-a50);
                border-radius: 24px;
                border: 1px solid var(--white-a10);

                &.unread {
                  background: var(--navigation);
                  border: 1px solid var(--navigation);
                  color: #181919;
                }
              }

              .candidate-content {
                display: flex;
                flex-direction: column;
                gap: 2px;
                font-family: Lato;
                flex: 1 1 100%;
                width: 0;
                word-wrap: break-word;
                .candidate-name-and-date {
                  display: flex;
                  .candidate-name {
                    font-weight: bold;
                  }

                  .candidate-closed {
                    font-family: Lato;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 700;
                    padding: 0px 8px;
                    border-radius: 16px;
                    border: 1px solid var(--negative-a50);
                    text-transform: lowercase;
                    margin: 0 9px;
                    align-self: baseline;
                  }

                  .candidate-date {
                    margin-left: auto;
                    color: #738080;
                  }
                }
              }
            }
          }
        }
      }
      .candidate-chat {
        flex: 0 0 50%;
        width: 0;

        .candidate-selected {
          display: flex;
          flex-direction: column;
          gap: 16px;
          height: 100%;
          padding: 16px;

          .candidate-selected-messages {
            display: flex;
            flex-direction: column;
            flex: 1 1 100%;
            border-radius: 6px;
            border: 1px solid var(--white-a25);

            .f-sexy-scroll {
              height: 0;
              flex: 1 1 auto;
              .scroll-items {
                display: flex;
                flex-direction: column;
                padding: 8px;
              }
            }

            .f-button-link {
              align-self: center;
            }

            .request {
              display: flex;
              flex-direction: column;
              gap: 4px;
              font-family: Lato;
              padding: 8px;

              .author {
                font-weight: bold;
                word-wrap: break-word;
              }

              .text {
                word-wrap: break-word;
              }

              .date {
                color: #bbbbbb;
                font-weight: 400;
                font-size: 12px;
              }
            }
          }

          .actions {
            display: flex;
            gap: 16px;
          }
        }
      }
      .no-candidate-selected {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: var(--white-a75);

        .f-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          font-size: 18px;
          border-radius: 100%;
          border: 4px solid var(--white-a75);
          margin-bottom: 14px;
          color: var(--white-a75);
        }
      }
    }
  }
}
.stepin-player-chat-textarea {
  .f-field.f-textarea {
    &.disabled {
      .actions {
        background: var(--black-5, #18181a0d);
      }
    }
  }

  .f-input-container {
    height: 64px;
    background-color: white;

    textarea.f-input {
      height: 100%;

      &[disabled] {
        background: var(--black-5, rgba(24, 24, 26, 0.05));
      }

      &::placeholder {
        color: black;
      }

      &[disabled]::placeholder {
        color: var(--black-25, rgba(24, 24, 26, 0.25));
      }
    }

    .actions {
      height: 100%;
      width: 40px;
      padding: 8px 4px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      button.f-button {
        color: #209fdf;
        width: 32px;
        height: 32px;
        font-size: 16px;
      }
    }
  }
}
.dark-mode {
  .stepin-vconsole17 {
    .content-container {
      margin: 0;
      .content {
        margin: 0;
        padding: 0;
      }
    }
  }
}
</style>
